module.exports = __webpack_public_path__ + "img/store-grey.f5b35d9d.png";